
export default {
  debounce (id, callback, delay = 500) {
    const inputing = 'inputing-' + id
    const timeout = 'timeout-' + id
    this[inputing] = true
    if (this[timeout]) {
      clearTimeout(this[timeout])
    }
    this[timeout] = setTimeout(async () => {
      if (this[inputing]) {
        await callback()
        this[inputing] = false
      }
    }, delay)
  },
  fixNumber (value, max, dot) {
    value = value + ''
    if (!value) {
      return value
    } else {
      if (Number(value) > max) {
        value = value.replace(/.$/, '')
        this.debounce('checkNumber', () => {
          message.error('输入不得超过' + max)
        })
        return this.fixNumber(value, max, dot)
      }
      if (dot > 0) {
        const reg = /^(0|[1-9]\d*)($|\.\d{0,2}$)/
        if (reg.test(value)) {
          return value
        } else {
          value = value.replace(/.$/, '')
          this.debounce('checkNumber', () => {
            message.error('请输入合法的' + dot + '位以内小数')
          })
          return this.fixNumber(value, max, dot)
        }
      }
      return value
    }
  },
  checkNumber (value, max, dot = 0) {
    value = (value + '').replace(/。/g, '.').replace(/[^\d\\.]/g, '')
    if (max > 0 || dot > 0) {
      value = this.fixNumber(value, max, dot)
    } else {
      value = (value + '').replace(/[^\d]/g, '')
    }
    return value
  },
  find (list, key = 'id', val = 'name', value = 0) {
    for (const i in list) {
      if (list[i][key] === value) {
        if (val) {
          return list[i][val]
        } else {
          return list[i]
        }
      }
    }
    return ''
  },
  findTree (tree, key = 'id', val = 'name', value = 0, children = 'children') {
    const res = this.find(tree, key, val, value)
    if (res === '') {
      for (const i in tree) {
        const list = tree[i][children]
        const treeRes = this.findTree(list, key, val, value, children)
        if (treeRes !== '') {
          return treeRes
        }
      }
      return ''
    } else {
      return res
    }
  },
  values (list, key, val, value) {
    const res = []
    for (const i in list) {
      if (list[i][key] === value) {
        res.push(list[i][val])
      }
    }
    return res
  },
  isIP (str) {
    return /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(str)
  },
  isArray (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]'
  },
  isObject (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]'
  },
  log (...arr) {
    console.log(arr)
  },
  /**
   * 秒数格式化
   * @param duration 秒数
   * @param fmt Y年M个月D天H小时m分钟s秒
   * @returns {string}
   */
  formatDuration (duration, fmt = 'Y年M个月D天H小时m分钟s秒') {
    const ms = 60
    const Hs = ms * 60
    const Ds = Hs * 12
    const Ms = Ds * 30
    const Ys = Ms * 12

    const Y = Math.floor(duration / Ys)
    const M = Math.floor((duration - Y * Ys) / Ms)
    const D = Math.floor((duration - Y * Ys - M * Ms) / Ds)

    const H = Math.floor((duration - Y * Ys - M * Ms - D * Ds) / Hs)
    const m = Math.floor((duration - Y * Ys - M * Ms - D * Ds - H * Hs) / ms)
    const s = Math.floor(duration - Y * Ys - M * Ms - D * Ds - H * Hs - m * ms)
    const obj = { 'Y+': Y, 'M+': M, 'D+': D, 'H+': H, 'm+': m, 's+': s }
    for (const k in obj) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? obj[k]
            : ('00' + obj[k]).substr(('' + obj[k]).length)
        )
      }
    }
    return fmt
  },
  isNull (obj) {
    if (obj === undefined) {
      return true
    } else if (obj === null) {
      return true
    } else if (obj === '') {
      return true
    } else if (this.isArray(obj) && obj.length === 0) {
      return true
    } else if (this.isObject(obj) && JSON.stringify(obj) === '{}') {
      return true
    } else {
      return false
    }
  },
}
